<template>
  <div>
    <br />
    <h2 class="ViewHeading text-left">Notifications</h2>
    <div>
      <b-row
        ><b-col>
          <h4>{{ this.selectedlocation }}</h4>
        </b-col></b-row
      >
      <br />
        <b-card v-if="ProfilePortal == 'SEN'">
          <NotificationsSEN />
          </b-card>
  
      <b-card v-if="ProfilePortal != 'SEN'" no-body>
        <ClarenceNotifications />
      </b-card>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import NotificationsSEN from "@/components/SeniorUserComponents/AlertsSEN.vue";
import ClarenceNotifications from "@/components/NotificationComponents/ClarenceNotifications.vue";


export default {
  computed: {},
  components: {
    NotificationsSEN,
    ClarenceNotifications

  },

  data() {
    return {
      UserAccess: localStorage.getItem("accessGroup"),
      ProfilePortal: localStorage.getItem("profileportal"),
      response: null,
      selectedlocation: localStorage.getItem("CurrentLocation"),
      clarenceAlertCount: "-",
      handwashAlertCount: "-",
      waterManagementAlertCount: "-",
      highPriorityAlertCount: "-",
      mediumPriorityAlertCount: "-",
      infoAlertCount: "-",
    };
  },

  beforeMount() {},

  mounted() {
    let LookUpCountUrl =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/counts";
    let LookUpCountHeaders = this.$apikeyPost;
    this.LookUpRequest = {
      RequestType: "Alerts",
      RequestVariable: this.selectedlocation,
    };
    axios
      .post(LookUpCountUrl, this.LookUpRequest, LookUpCountHeaders)
      .then((response) => {

        this.clarenceAlertCount = response.data.ClarenceAlertCount;
        this.handwashAlertCount = response.data.UnitAlertCount;
        this.waterManagementAlertCount = response.data.WMSAlertCount;
        this.highPriorityAlertCount = response.data.HighPriorityCount;
        this.mediumPriorityAlertCount = response.data.MediumPriorityCount;
        this.infoAlertCount = response.data.TotalInfoCount;
      });
  },

  methods: {
    // SetCounts(values){
    //   console.log("Set Counts Called")
    //   console.log(values)
    // },
    // scroll_left() {
    //   let content = document.querySelector(".nav-tabs");
    //   content.scrollLeft -= 50;
    // },
    // scroll_right() {
    //   let content = document.querySelector(".nav-tabs");
    //   content.scrollLeft += 50;
    // },
    // UpdateCounts() {
    //   let LookUpCountUrl =
    //     "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
    //     this.$environment +
    //     "/counts";
    //   let LookUpCountHeaders = this.$apikeyPost;
    //   this.LookUpRequest = {
    //     RequestType: "Alerts",
    //     RequestVariable: this.selectedlocation,
    //   };
    //   axios
    //     .post(LookUpCountUrl, this.LookUpRequest, LookUpCountHeaders)
    //     .then((response) => {
    //       this.clarenceAlertCount = response.data.ClarenceAlertCount;
    //       this.handwashAlertCount = response.data.UnitAlertCount;
    //       this.waterManagementAlertCount = response.data.WMSAlertCount;
    //       this.highPriorityAlertCount = response.data.HighPriorityCount;
    //       this.mediumPriorityAlertCount = response.data.MediumPriorityCount;
    //       this.infoAlertCount = response.data.TotalInfoCount;
    //     });
    // },
  },
};
</script>

<style>
.nav-tabs {
  flex-wrap: nowrap;
  white-space: nowrap;
  overflow: auto;
  overflow-y: hidden;
}

.wrap {
  overflow: hidden;
  width: 100%;
  flex-direction: row;
}

p.badgetext {
  font-size: medium;
  color: white;
}
h4 {
  padding: 0px;
  margin: 0px;
}
</style>
